function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAhilLitelLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "200px",
    height: "200px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.939
    },
    fill: "#fefffe",
    d: "M 14.5,38.5 C 24.5056,38.3335 34.5056,38.5002 44.5,39C 50.9913,40.4826 56.1579,43.9826 60,49.5C 63.1822,55.8644 66.3489,62.1978 69.5,68.5C 80.6532,76.9125 92.3198,84.5791 104.5,91.5C 109.98,98.1479 115.647,104.648 121.5,111C 144.329,123.58 166.996,136.414 189.5,149.5C 184.869,150.662 180.202,150.828 175.5,150C 155.193,142.231 134.693,135.065 114,128.5C 106.85,129.203 99.6838,129.703 92.5,130C 86.1667,135.667 79.8333,141.333 73.5,147C 76.7627,148.226 80.096,149.393 83.5,150.5C 65.0713,151.311 46.738,151.311 28.5,150.5C 34.6306,148.215 40.9639,146.381 47.5,145C 52.9586,142.368 58.292,139.535 63.5,136.5C 64.7596,134.647 64.7596,132.814 63.5,131C 48.2095,123.127 36.0429,111.96 27,97.5C 23.4175,84.5527 23.9175,71.7193 28.5,59C 27.4724,55.7789 26.3058,52.6123 25,49.5C 21.2469,45.9173 17.7469,42.2506 14.5,38.5 Z M 71.5,138.5 C 69.3336,140.837 67.3336,143.337 65.5,146C 62.2397,146.975 59.073,148.142 56,149.5C 55.3162,148.216 55.4829,147.049 56.5,146C 61.2432,142.962 66.2432,140.462 71.5,138.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAhilLitelLogo);
export default __webpack_public_path__ + "static/media/ahil_litel_logo.8b0fc1604e3327939b9230abd8608878.svg";
export { ForwardRef as ReactComponent };